module.exports = __webpack_public_path__ + "img/pr-2.97c94c4c.png";